import React from 'react';

import { Icon } from './iconElement';

export const NewIcon = (props) => {
  return <Icon {...props} />;
};
